module.exports = __webpack_public_path__ + "static/media/mastek.0afcb456.svg";